import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormGroupType } from '../../../../../core/models/form-group-type';
import { RegExPattern } from '../../../../../core/models/regexp-pattern/regex-pattern';
import { OrderConstants } from '../../shared/constants/order-constants';
import { OrderStatus } from '../../shared/constants/order-status';
import { PaymentDetailsFormModel } from '../models/payment-details-form-model';

@Injectable({
    providedIn: 'root',
})
export class PaymentDetailsFormService {
    getFormDefinition(): FormGroup<FormGroupType<PaymentDetailsFormModel>> {
        return new FormGroup<FormGroupType<PaymentDetailsFormModel>>({
            status: new FormControl<OrderStatus | null>(
                null,
                Validators.required,
            ),
            poNumber: new FormControl<string | null>(null, [
                Validators.maxLength(OrderConstants.MAX_PO_NUMBER_LENGTH),
                Validators.pattern(
                    RegExPattern.PrintableAsciiExceptAngleBracketsAndPipes,
                ),
            ]),
        });
    }

    /**
     * Resets the payment details form to its initial state.
     */
    resetForm(form: FormGroup<FormGroupType<PaymentDetailsFormModel>>): void {
        form.reset({}, { emitEvent: false });
    }
}
